// import $ from "jquery"
import {
  articleCategoryId,
  globalUserId,
  //  initForm,
  //  getSess,
  isSetting,
  browerType,
  updateSearchParam
} from "../common/sbase";
import { articleListSettingInfo } from "../common/settingData";
import { $subscriber, interact, URLS } from "fire-wind-water";
import service from "../services/article";
import template from "../mixin/template";
import Pager from "../components/Pager";
export default {
  name: "Banner",
  mixins: [template],
  data() {
    return {
      list: [],
      pageSize: 9, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数,
      id: "",
      isFirst: true,
      isSetting: false,
      noWxAuth: 0,
      title: "",
      categoryInfo: {},
      extras: {},
      userInfo: {},
      color: {
        title: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        },
        summary: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        },
        time: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        }
      }
    };
  },
  created() {
    console.log(this.$route.path);
    this.noWxAuth = URLS.getHash("noWxAuth") || URLS.getURL("noWxAuth");
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
    window.$sk.loading.show("正在读取数据");
    window.$sk.template.module(this);
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.userInfo = window.$sk.template.get();
      console.log(info);
      this.schemaId = info.common.schemaId;
      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      //      $subscriber.emit('user-info',info.user);
      ////      this.contactInfo = info.user;
      ////      this.moduleId = info.common.moduleId;
      ////      this.getData();
      //      this.load();
      this.initConfig(URLS.getURL("configId"), this.tenantId);
      if (this.$route.path.toLowerCase().indexOf("morecolumn") > 0) {
        //多栏目模板
        //        this.id = articleCategoryId;
        //        this.getList(false);
        $subscriber.off("get-actile-list");
        $subscriber.subscribe("get-actile-list", id => {
          this.id = id;
          this.currentPage = 1;
          if (!isSetting) {
            this.getList(true);
          } else {
            this.isSetting = true;
            this.getSettingData();
          }
        });
        //没有子栏目的情况下获取目录信息
        $subscriber.off("category-info");
        $subscriber.subscribe("category-info", info => {
          this.categoryInfo2 = info; //用于判断pc wap 专用别改
          this.categoryInfo4 = info;
          if (!this.checkDevice()) {
            return;
          }
          //  debugger;
          if (info.articleCategoryId != URLS.getURL("articleCategoryId")) {
            this.getList(false, info.articleCategoryId);
          }
          if (info.subCategories.length == 0) {
            window.$sk.template.update({
              type: "link",
              data: {
                identity: info.identity,
                weChatId: "",
                skObjectType: "article",
                skObjectId: articleCategoryId,
                meetingInstanceId: "",
                meetingType: 0,
                memberFormId: info.registerFormId
              }
            });
          }
        });
        $subscriber.subscribe("category-title", title => {
          this.title = title;
        });
      } else {
        this.id = articleCategoryId;
        if (!isSetting) {
          this.getList(true);
        } else {
          this.isSetting = true;
          this.getSettingData();
        }
      }
    },
    skUserChange() {
      console.log("用户信息发生改变");
    },
    skLinkEnd(e) {
      console.log("跳转逻辑判断完毕");
      if (!e.isJump) {
        if (
          (parseInt(this.categoryInfo.bindWeChatId) ||
            (parseInt(this.categoryInfo.authorisedWeChatId) &&
              this.categoryInfo.authorisedType == 1)) &&
          interact.isWeChat &&
          (!this.userInfo.user.tokenInfo ||
            !this.userInfo.user.tokenInfo.nickname)
        ) {
          //显授权并且没有nickName
          window.$sk.template.update({
            type: "auth",
            data: {
              weChatId:
                parseInt(this.categoryInfo.bindWeChatId) ||
                this.categoryInfo.authorisedWeChatId,
              scope:
                this.categoryInfo.authorisedType == 1
                  ? "snsapi_userinfo"
                  : "snsapi_base"
            }
          });
        } else {
          this.initWeChatShare();
          window.$sk.loading.hide();
          this.browse();
        }
        //        interact;
        //        window.$sk.loading.hide();
        //        $subscriber.emit("article-info", this.articleInfo);
        //
        //        if(this.articleInfo.authorisedType ==1 && interact.isWeChat && !this.userInfo.user.tokenInfo){//显授权并且没有nickName
        //          debugger
        //          window.$sk.template.update({
        //            type: "auth",
        //            data: {
        //              weChatId: this.articleInfo.authorisedWeChatId,
        //              scope:'snsapi_userinfo'
        //            },
        //          });
        //        }else{
        //          this.browse();
        //          window.$sk.loading.hide();
        //        }
      }
    },
    skAuthEnd(e) {
      this.userInfo.user.tokenInfo = e.tokenInfo;
      this.userInfo.user.openId = e.tokenInfo.original.openid;
      this.initWeChatShare();
      window.$sk.loading.hide();
      this.browse();
    },
    checkDevice() {
      // 如果是多栏目需要获取当前目录信息再跳转
      if (window.location.href.indexOf("local") > 0) {
        return true;
      }

      if (browerType == "pc" && location.href.indexOf("wap") > 0) {
        if (
          this.categoryInfo2.id == articleCategoryId ||
          this.categoryInfo2.articleCategoryId == articleCategoryId
        ) {
          window.$sk.goto(this.categoryInfo2.PCShortUrlLink);
        }
        return false;
      }
      if (browerType == "mobile" && location.href.indexOf("wap") < 0) {
        if (
          this.categoryInfo2.id == articleCategoryId ||
          this.categoryInfo2.articleCategoryId == articleCategoryId
        ) {
          window.$sk.goto(this.categoryInfo2.shortUrlLink);
        }

        return false;
      }
      return true;
    },

    getList(isMore, id) {
      //isMore 是否加载多栏目的列表
      //id 多栏目下获取当前主目录的信息，传的ID，其他时候用this.id
      let param = {
        articleCategoryId: id || this.id,
        globalUserId: globalUserId,
        instanceId: "",
        isRecommend: -1,
        isStick: -1,
        moduleId: "",
        num: this.pageSize,
        orderField: -1,
        start: (this.currentPage - 1) * this.pageSize,
        title: "",
        typeId: "",
        withStat: -1,
        withTemplate: 1
      };
      service.getArticleList(param).subscribe(data => {
        data.content.category.bindWeChatId = data.content.category.weChatId;

        this.categoryInfo3 = data.content.category;
        if (isMore) {
          this.list = data.content.items;
          this.categoryInfo = data.content.category;
          this.categoryInfo2 = data.content.category;
          if (!this.checkDevice()) {
            return;
          }
        } else {
          this.categoryInfo4 = data.content.category;
          if (!this.checkDevice()) {
            return;
          }
        }

        if (!isMore) {
          return;
        }

        this.count = parseInt(data.content.total);

        if (this.isFirst) {
          //          initForm(
          //            data.content.category.identity,
          //            data.content.category.schemaId,
          //            data.content.category.registerFormId,
          //            data.content.category.tenantId
          //          );
          if (
            this.categoryInfo3.weChatId &&
            this.categoryInfo3.weChatId != "0"
          ) {
            service
              .getAppId({
                weChatId: this.categoryInfo3.weChatId,
                wechatId: this.categoryInfo3.weChatId
              })
              .subscribe(data1 => {
                this.categoryInfo3.bindWeChatId = data1.content.weChatId; //获取用来授权的微信号
                window.$sk.template.update({
                  type: "link",
                  data: {
                    identity: data.content.category.identity,
                    weChatId: "",
                    skObjectType: "article",
                    skObjectId: articleCategoryId,
                    meetingInstanceId: "",
                    meetingType: 0,
                    memberFormId: data.content.category.registerFormId
                  }
                });
              });
          } else {
            window.$sk.template.update({
              type: "link",
              data: {
                identity: data.content.category.identity,
                weChatId: "",
                skObjectType: "article",
                skObjectId: articleCategoryId,
                meetingInstanceId: "",
                meetingType: 0,
                memberFormId: data.content.category.registerFormId
              }
            });
          }
          this.isFirst = false;
          // window.$s_temp.loading.hide();//隐藏loading

          //          if(data.content.category.identity == 3 && getSess(data.content.category.schemaId) == "") {
          //            //登陆后参与并且没有登录
          //            //nothing
          //          }else {
          //            if(globalUserId){
          //              this.browse(data.content.category,globalUserId);
          //            }else{
          //              $subscriber.subscribe('globalUserId-loaded',id=>{
          //                this.browse(data.content.category,id);
          //              });
          //            }
          //          }

          if (this.$route.path.toLowerCase().indexOf("morecolumn") > 0) {
            //
          } else {
            this.title = data.content.category.title;
          }
        }
      });
    },
    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const info =
        this.$route.path.toLowerCase().indexOf("morecolumn") > 0 &&
        this.categoryInfo4
          ? this.categoryInfo4
          : this.categoryInfo3;
      const shareInfo = {
        title: info.shareTitle || "", // 分享标题,
        desc: info.shareDesc || "", // 分享描述,
        link: info.longUrlLink || info.shortUrlLink || window.location.href,
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "" // 分享图标
      };

      window.$swxsdk.initWxSdk(
        { tenantId: this.tenantId },
        window.$sk.config.apiUrl
      );
      if (info.shareState == 0) {
        window.$swxsdk.on(
          "hideMenuList",
          {
            menuList: [
              "menuItem:share:appMessage",
              "menuItem:share:timeline",
              "menuItem:share:qq",
              "menuItem:share:weiboApp",
              "menuItem:share:facebook",
              "menuItem:share:QZone",
              "menuItem:copyUrl",
              "menuItem:openWithQQBrowser",
              "menuItem:openWithSafari"
            ]
          },
          function(result) {
            console.log(result);
          }
        );
        window.$swxsdk.on("hideOptionMenu");
      } else {
        window.$swxsdk.on("sharer", shareInfo);
        window.$swxsdk.on("sharer_friends", shareInfo);
      }
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(true);
    },
    go(item) {
      if (interact.isMobile) {
        window.$sk.goto(
          updateSearchParam(
            "back_returnUrl",
            encodeURIComponent(window.location.href),
            item.url
          )
        );
      } else {
        window.$sk
          .goto(
            updateSearchParam(
              "back_returnUrl",
              encodeURIComponent(window.location.href),
              item.PCUrl
            ),
            true
          )
          .subscribe(res => {
            window.open(res);
          });
      }
    },
    browse() {
      let param = {
        articleCategoryId: articleCategoryId,
        browseInfo: {},
        currentUrl: window.location.href,
        globalUserId: this.globalUserId,
        openId: this.userInfo.user.openId || "",
        sess: this.sess,
        source: interact.isMobile ? "wap" : "pc",
        tenantId: this.tenantId,
        weChatId:
          parseInt(this.categoryInfo3.weChatId) ||
          parseInt(this.categoryInfo3.authorisedWeChatId) ||
          ""
      };
      service.browseCategory(param).subscribe(data => {
        data;
      });
    },
    getSettingData() {
      this.list = articleListSettingInfo;
      this.count = 222;

      window.$sk.loading.hide();
    }
  },
  mounted() {
    //IE 需要单独处理下
    // console.log($('#a')[0].scrollHeight)
  },
  components: { Pager }
};
